import React, { useState } from "react";
import filter from "../../../../assets/img/icons/setting-4.svg";
import flash from "../../../../assets/img/icons/flash 3.svg";
import location from "../../../../assets/img/icons/location 3.svg";
import calander from "../../../../assets/img/icons/calendar-2 2.svg";
import people from "../../../../assets/img/icons/people 2.svg";
import money from "../../../../assets/img/icons/moneys.svg";
import building from "../../../../assets/img/icons/building-4.svg";
import note from "../../../../assets/img/icons/note-2 2.svg";
import Button from "../../../shared/Button";
import Slider from "react-slick/lib/slider";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";

const ResidenceFilter = ({
  openGuestModal,
  openCostModal,
  openFastDeliverModal,
  openCityModal,
  opentTypeModal,
  openFirstDateModal,
  openSecDateModal,
  FirstDateValue,
  SecDateValue,
  chosenCity,
  count,
  useFilter,
  OrderingSort,
  setShowRegModal,
  setOrderingSort
}) => {
  const [expand, setExpand] = useState(true);
  console.log(FirstDateValue)
   //popular//minp//maxp
  return (
    <div className="">
      <div className={`ResidenceFilter ${expand ? "ResidenceFilter-expand" : ""}`}>
       

        <div className="ResidenceFilter--body">
          <Swiper spaceBetween={32} slidesPerView={6}>
            <SwiperSlide>
              
              {" "}<Button varient="white" onClick={openFastDeliverModal}>
                <div className="flex items-center">
                  <img src={flash} className="ml-[8px]" />
                  <p> تحویل فوری</p>
                </div>
              </Button>
            </SwiperSlide>
            <SwiperSlide>
              {" "}<Button varient="white" onClick={openCityModal}>
                <div className="flex items-center">
                  <img src={location} className="ml-[8px]" />
                  {/* {chosenCity.length === 0
                    ? <p> انتخاب شهر</p>
                    : <p>
                        {chosenCity[0].title},...
                      </p>} */}
                       <p> انتخاب شهر</p>
                </div>
              </Button>
            </SwiperSlide>
            <SwiperSlide>
              {" "}<Button varient="white" onClick={openFirstDateModal}>
                <div className="flex items-center">
                  <img src={calander} className="ml-[8px]" />
                  {/* {FirstDateValue === null
                    ? <p>تاریخ ورود </p>  */}
                   {/* : <p>
                       {typeof FirstDateValue === "string" ? FirstDateValue :FirstDateValue.format()}  
                     </p>} */}
                    <p>تاریخ ورود </p> 
                </div>
              </Button>
            </SwiperSlide>
            <SwiperSlide>
              {" "}<Button varient="white" onClick={openSecDateModal}>
                <div className="flex items-center">
                  <img src={calander} className="ml-[8px]" />
                  {/* {SecDateValue === null
                    ? <p>تاریخ خروج</p>
                    : <p>
                 {typeof SecDateValue === "string" ?  SecDateValue :SecDateValue.format()}  
                      </p>} */}
                      <p>تاریخ خروج</p>
                </div>
              </Button>
            </SwiperSlide>
            <SwiperSlide>
              {" "}<Button varient="white" onClick={openGuestModal}>
                <div className="flex items-center">
                  <img src={people} className="ml-[8px]" />
                  {count > 0
                    ? <p>
                        {count} نفر
                      </p>
                    : <p> تعداد نفرات</p>}
                </div>
              </Button>
            </SwiperSlide>
            <SwiperSlide>
              <Button varient="white" onClick={openCostModal}>
                <div className="flex items-center">
                  <img src={money} className="ml-[8px]" />
                  <p> محدوده قیمت</p>
                </div>
              </Button>
            </SwiperSlide>
            <SwiperSlide>
              <Button varient="white" onClick={() => opentTypeModal(true)}>
                <div className="flex items-center">
                  <img src={building} className="ml-[8px]" />
                  <p> نوع اقامتگاه</p>
                </div>
              </Button>
            </SwiperSlide>
            <SwiperSlide>
              {" "}<Button varient="white" onClick={()=>setShowRegModal()}>
                <div className="flex items-center">
                  <img src={note} className="ml-[8px]" />
                  <p> قوانین اقامتگاه</p>
                </div>
              </Button>
            </SwiperSlide>
          </Swiper>
        </div>
      </div>
    </div>
  );
};



export default ResidenceFilter